<template>
    <div class="container-fluid">
      <div class="page-title">
        <h4>Agenda</h4>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-block">
              <div class="col-md-10 ml-auto mr-auto">
                <form action="">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="form-group">
                                <label>Sélectionnez l'agenda de outil à afficher : </label>
                                <select class="form-control" v-model="selectedSytem" required>
                                    <option v-bind:value="null" selected>Choisissez un outil</option>
                                    <option v-for="system in systems" v-bind:value="system" v-bind:key="system.id">
                                        {{system.name}} - Code : {{system.code}}
                                    </option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="text-right mrg-top-5">
                        <button type="button" class="btn btn-primary" v-bind:disabled="selectedSytem == null" v-on:click="next">Suivant</button>
                    </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>

import { mapGetters } from 'vuex';

export default {
	name: 'CalendarSelectView',
	data: () => ({
		selectedSytem: null,
	}),
	mounted() {
		this.$store.dispatch('systems/getSystems');
	},
	computed: {
		...mapGetters({
			systems: 'systems/systems'
		}),
	},
	methods : {
		next() {
			this.$router.push({ path: `/calendar/${this.selectedSytem.id}` });
		}
	}
}
</script>
